import styled, { keyframes } from 'styled-components'

// ── paleta do PORTAL DO RESPONSÁVEL (esmeralda — combina com o login) ──
const TEAL = '#0f6e52'        // esmeralda principal
const TEAL_LIGHT = '#14916b'  // esmeralda clara
const TEAL_DEEP = '#0a4d3a'   // esmeralda profunda (gradiente do hero)
const TEAL_SOFT = '#e6f4ee'   // esmeralda suave
const CORAL = 'var(--coral)'
const GRAY_BG = '#f4f7f5'
const GRAY_LINE = '#e0e8e4'
const GRAY_TEXT = '#566b62'
const GRAY_DARK = '#23332c'
const TEAL_GLOW = 'rgba(15, 110, 82, 0.22)'

const GREEN = 'var(--green)'
//const AMBER = '#b9770e'
const RED = 'var(--red, #dc2626)'

const bp = { tablet: '900px', mobile: '540px' }

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
`

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`

// === PÁGINA: cobre a viewport inteira, independente do container pai ===
export const Page = styled.div`
  /* ancora nos 4 cantos da janela — ignora qualquer wrapper/centralização do App */
  position: fixed;
  inset: 0;                 /* top:0 right:0 bottom:0 left:0 */
  overflow-y: auto;         /* scroll próprio do conteúdo */
  box-sizing: border-box;
  z-index: 1;
  background:
    radial-gradient(1200px 380px at 75% -120px, rgba(20, 145, 107, 0.08), transparent 70%),
    ${GRAY_BG};
`

// === HERO: colado no topo, de borda a borda ===
export const Hero = styled.header`
  width: 100%;
  background: linear-gradient(135deg, ${TEAL} 0%, ${TEAL_DEEP} 100%);
  color: #fff;
  position: relative;
  overflow: hidden;

  /* arco luminoso sutil, mesma linguagem do login */
  &::after {
    content: '';
    position: absolute;
    right: -140px;
    top: -160px;
    width: 420px;
    height: 420px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.10) 0%, transparent 70%);
    pointer-events: none;
  }
`

export const HeroInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  position: relative;
  z-index: 1;

  @media (max-width: ${bp.mobile}) {
    padding: 26px 18px;
    align-items: flex-start;
  }
`

export const HeroLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  min-width: 0;

  @media (max-width: ${bp.mobile}) {
    gap: 14px;
  }
`

export const HeroAvatar = styled.div`
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 22px;
  color: #fff;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.16);
  border: 1.5px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(4px);

  @media (max-width: ${bp.mobile}) {
    width: 52px;
    height: 52px;
    border-radius: 16px;
    font-size: 18px;
  }
`

export const HeroText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
`

export const HeroGreeting = styled.h1`
  margin: 0;
  font-size: clamp(22px, 3vw, 32px);
  font-weight: 800;
  letter-spacing: -0.4px;
  line-height: 1.1;
  word-break: break-word;
`

export const HeroSubtitle = styled.p`
  margin: 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.82);
  max-width: 52ch;

  @media (max-width: ${bp.mobile}) {
    font-size: 13.5px;
  }
`

export const HeroCount = styled.span`
  margin-top: 4px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  font-size: 12.5px;
  font-weight: 700;
  color: #fff;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.22);
  padding: 4px 12px;
  border-radius: 999px;
`

export const LogoutButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.10);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  padding: 11px 20px;
  border-radius: 11px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;

  &:hover { background: rgba(255, 255, 255, 0.2); border-color: rgba(255, 255, 255, 0.65); transform: translateY(-1px); }
  &:active { transform: translateY(0); }

  @media (max-width: ${bp.mobile}) {
    padding: 9px 16px;
    font-size: 13px;
  }
`

// === CONTEÚDO ===
export const Content = styled.main`
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 32px 56px;
  animation: ${fadeUp} 0.4s ease;

  @media (max-width: ${bp.mobile}) {
    padding: 24px 18px 44px;
  }
`

export const SectionHead = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
`

export const SectionLabel = styled.h2`
  margin: 0;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: ${GRAY_TEXT};
`

export const SectionCount = styled.span`
  font-size: 12px;
  font-weight: 800;
  color: ${TEAL};
  background: ${TEAL_SOFT};
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const StudentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 18px;

  @media (max-width: ${bp.mobile}) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`

// === CARD DO ALUNO (horizontal, escaneável) ===
export const StudentCard = styled.div`
  position: relative;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 18px;
  padding: 20px 20px 20px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  overflow: hidden;
  animation: ${fadeUp} 0.35s ease;
  transition: box-shadow 0.18s ease, transform 0.14s ease, border-color 0.18s ease;

  &:hover {
    box-shadow: 0 14px 30px rgba(15, 110, 82, 0.14);
    transform: translateY(-3px);
    border-color: ${TEAL_SOFT};
  }
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(20, 145, 107, 0.25);
    border-color: ${TEAL_LIGHT};
  }
  &:hover .go-icon { color: ${TEAL}; gap: 8px; }
`

// faixa de cor por status na borda esquerda
export const CardAccent = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  ${({ $status }) => {
    switch (($status || '').toLowerCase()) {
      case 'ativo': return `background: linear-gradient(${GREEN}, ${TEAL_LIGHT});`
      case 'transferido': return `background: ${CORAL};`
      case 'inativo': return `background: #9aa5aa;`
      case 'concluido': return `background: linear-gradient(${TEAL}, ${TEAL_LIGHT});`
      default: return `background: ${GRAY_LINE};`
    }
  }}
`

export const StudentAvatar = styled.div`
  flex-shrink: 0;
  width: 58px;
  height: 58px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 19px;
  color: #fff;
  text-transform: uppercase;
  background: linear-gradient(135deg, ${TEAL}, ${TEAL_LIGHT});
  box-shadow: 0 5px 14px ${TEAL_GLOW};
`

export const CardBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
`

export const StudentName = styled.strong`
  font-size: 16px;
  font-weight: 700;
  color: ${GRAY_DARK};
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const StudentMeta = styled.span`
  font-size: 13px;
  color: ${GRAY_TEXT};
`

export const CardFoot = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`

export const StatusBadge = styled.span`
  font-size: 11.5px;
  font-weight: 700;
  text-transform: capitalize;
  padding: 3px 12px;
  border-radius: 999px;
  letter-spacing: 0.2px;

  ${({ $status }) => {
    switch (($status || '').toLowerCase()) {
      case 'ativo':
        return `color: ${GREEN}; background: rgba(29, 139, 90, 0.12);`
      case 'transferido':
        return `color: ${CORAL}; background: rgba(224, 122, 95, 0.14);`
      case 'inativo':
        return `color: #6b7672; background: #eef1f0;`
      case 'concluido':
        return `color: ${TEAL_LIGHT}; background: ${TEAL_SOFT};`
      default:
        return `color: ${GRAY_TEXT}; background: ${GRAY_BG}; border: 1px solid ${GRAY_LINE};`
    }
  }}
`

export const GoIcon = styled.span.attrs({ className: 'go-icon' })`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 700;
  color: ${GRAY_TEXT};
  transition: color 0.15s ease, gap 0.15s ease;
  white-space: nowrap;
`

// === ESTADO VAZIO / ERRO ===
export const EmptyBox = styled.div`
  background: var(--surface);
  border: 1px dashed ${GRAY_LINE};
  border-radius: 18px;
  padding: 48px 28px;
  text-align: center;
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  span {
    font-size: 14px;
    font-weight: 400;
    color: ${GRAY_TEXT};
    max-width: 40ch;
  }
`

export const EmptyIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  ${({ $tone }) =>
    $tone === 'error'
      ? `color: ${RED}; background: rgba(192, 57, 43, 0.10);`
      : `color: ${TEAL}; background: ${TEAL_SOFT};`}
`

// === SKELETON ===
export const SkeletonCard = styled.div`
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 18px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`

export const SkeletonAvatar = styled.div`
  width: 58px;
  height: 58px;
  border-radius: 16px;
  background: linear-gradient(90deg, #eef2f0 25%, #e2e8e5 37%, #eef2f0 63%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s infinite linear;
`

export const SkeletonLine = styled.div`
  width: ${({ $w }) => $w || '100%'};
  height: ${({ $h }) => $h || '12px'};
  border-radius: 7px;
  background: linear-gradient(90deg, #eef2f0 25%, #e2e8e5 37%, #eef2f0 63%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s infinite linear;
`